import { InternalActionKeyId } from '@/define/internal_action_keys'

export const jingtaiV2DeviceFunctionActionKeys: InternalActionKeyId[] = [
  InternalActionKeyId.deviceLightBrightnessDown,
  InternalActionKeyId.deviceLightBrightnessUp,
  InternalActionKeyId.deviceLightSpeedDown,
  InternalActionKeyId.deviceLightSpeedUp,
  InternalActionKeyId.deviceLightEffectMode,
  InternalActionKeyId.deviceLightColorSwitch,
  InternalActionKeyId.deviceSwitchToWindowsMode,
  InternalActionKeyId.deviceSwitchToMacMode,
  InternalActionKeyId.deviceSwitchToProfile1,
  InternalActionKeyId.deviceSwitchToProfile2,
  InternalActionKeyId.deviceSwitchToProfile3,
  InternalActionKeyId.deviceSwitchToProfile4,
  // InternalActionKeyId.deviceFn1,
  // InternalActionKeyId.deviceFn2,
  InternalActionKeyId.deviceLightToggle,
]

const jingtaiV2ActionKeyByRawCode = new Map<number, InternalActionKeyId>([
  [0xf303, InternalActionKeyId.deviceLightBrightnessDown],
  [0xf302, InternalActionKeyId.deviceLightBrightnessUp],
  [0xf305, InternalActionKeyId.deviceLightSpeedDown],
  [0xf304, InternalActionKeyId.deviceLightSpeedUp],
  [0xf300, InternalActionKeyId.deviceLightEffectMode],
  [0xf301, InternalActionKeyId.deviceLightColorSwitch],
  [0xf101, InternalActionKeyId.deviceSwitchToWindowsMode],
  [0xf201, InternalActionKeyId.deviceSwitchToWindowsMode],
  [0xf202, InternalActionKeyId.deviceSwitchToMacMode],
  [0xf209, InternalActionKeyId.deviceWinKeyLock],
  [0xf205, InternalActionKeyId.deviceSwitchToProfile1],
  [0xf206, InternalActionKeyId.deviceSwitchToProfile2],
  [0xf207, InternalActionKeyId.deviceSwitchToProfile3],
  [0xf208, InternalActionKeyId.deviceSwitchToProfile4],
  [0xf102, InternalActionKeyId.deviceFn2],
  [0xf101, InternalActionKeyId.deviceFn1],
  [0xf307, InternalActionKeyId.deviceLightToggle],
])

const jingtaiV2RawCodeByActionKey = new Map<number, number>(Array.from(jingtaiV2ActionKeyByRawCode.entries()).map(([rawCode, actionKey]) => [actionKey, rawCode]))

jingtaiV2RawCodeByActionKey.set(InternalActionKeyId.deviceWinMacModeSwitch, 0xf201)

export const getJingtaiV2ActionKeyByRawCode = (rawCode: number): InternalActionKeyId | undefined => {
  return jingtaiV2ActionKeyByRawCode.get(rawCode)
}

export const getJingtaiV2RawCodeByActionKey = (id: number): number | undefined => {
  return jingtaiV2RawCodeByActionKey.get(id)
}
